module.exports = __webpack_public_path__ + "img/138.3.5b8c679f.png";